<template>

    <div class="faq " :class="{ 'open' : open }">

        <dt>
            <a class="inline-block"
               :class="open ? ' open' : ''"
               href="#"
               @click.prevent="toggleAnswer"
               @keypress.enter="toggleAnswer"
               @keypress.space="toggleAnswer">
                <slot></slot>
            </a>
        </dt>

        <Transition name="bounce">
            <dd v-if="open" class="py-2 leading-normal">
                <slot name="answer"></slot>
            </dd>
        </Transition>

    </div>
</template>

<script>
    export default {

        name: 'CollapsableRestyled',

        props: ['opened'],

        data() {
            return {
                open: this.opened,
            }
        },

        methods: {

            toggleAnswer() {
                this.open = !this.open;
            },

        },

    }
</script>

<style scoped>
    dt a {
        width:100%;
    }

    .bounce-enter-active {
        animation: fadeIn 0.8s;
    }
    .bounce-leave-active {
        animation: fadeIn 0.4s reverse;
    }
    @keyframes fadeIn {
        0% {
            opacity:0;
        }
        100% {
            opacity:1;
        }
    }

</style>



// WEBPACK FOOTER //
// web/app/themes/giles/resources/js/components/CollapseableRestyled.vue